export default __webpack_public_path__ + "static/media/soybean_milk_thumbnail.ae2ae561.JPG";